import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "eventname" })
export class EventNamePipe implements PipeTransform {
  transform(events: any[], value: string): any {
    if (!events) return [];
    if (!value || value.length == 0) return events;
    return events.filter(
      (event) =>
        (event.eventName &&
          event.eventName.toLowerCase().indexOf(value.toLowerCase()) >= 0) ||
        (event.code &&
          event.code.toLowerCase().indexOf(value.toLowerCase()) >= 0)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/event-name-pipe.ts